(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ProductLookup', ProductLookup);

  ProductLookup.$inject = ['$resource', 'API_URI'];

  function ProductLookup($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_lookup/all-products';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
